// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminBatchActionController from "./admin_batch_action_controller"
application.register("admin-batch-action", AdminBatchActionController)

import AdminClipboardController from "./admin_clipboard_controller"
application.register("admin-clipboard", AdminClipboardController)

import AdminDateFilterController from "./admin_date_filter_controller"
application.register("admin-date-filter", AdminDateFilterController)

import AdminInquiryFilterController from "./admin_inquiry_filter_controller"
application.register("admin-inquiry-filter", AdminInquiryFilterController)

import AdminPopupFormController from "./admin_popup_form_controller"
application.register("admin-popup-form", AdminPopupFormController)

import AdminSortableController from "./admin_sortable_controller"
application.register("admin-sortable", AdminSortableController)

import AgencyReferralModalController from "./agency_referral_modal_controller"
application.register("agency-referral-modal", AgencyReferralModalController)

import AgencyAccessValidationController from "./agency_access_validation_controller"
application.register("agency-access-validation", AgencyAccessValidationController)

import ApiKeyToggleController from "./api_key_toggle_controller"
application.register("api-key-toggle", ApiKeyToggleController)

import AuditLogFilterController from "./audit_log_filter_controller"
application.register("audit-log-filter", AuditLogFilterController)

import BannerSliderController from "./banner_slider_controller"
application.register("banner-slider", BannerSliderController)

import ByokVerifyController from "./byok_verify_controller"
application.register("byok-verify", ByokVerifyController)

import ModelsPageController from "./models_page_controller"
application.register("models-page", ModelsPageController)

import CanvasMobileController from "./canvas_mobile_controller"
application.register("canvas-mobile", CanvasMobileController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatbotWidgetController from "./chatbot_widget_controller"
application.register("chatbot-widget", ChatbotWidgetController)

import CockpitTabsController from "./cockpit_tabs_controller"
application.register("cockpit-tabs", CockpitTabsController)

import ColdmailCampaignController from "./coldmail_campaign_controller"
application.register("coldmail-campaign", ColdmailCampaignController)

import ColdmailLeadsController from "./coldmail_leads_controller"
application.register("coldmail-leads", ColdmailLeadsController)

import ConfirmModalController from "./confirm_modal_controller"
application.register("confirm-modal", ConfirmModalController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailComposeController from "./email_compose_controller"
application.register("email-compose", EmailComposeController)

import EnglishSpeakingSessionController from "./english_speaking_session_controller"
application.register("english-speaking-session", EnglishSpeakingSessionController)

import EnglishSpeakingFiltersController from "./english_speaking_filters_controller"
application.register("english-speaking-filters", EnglishSpeakingFiltersController)

import FaqAccordionController from "./faq_accordion_controller"
application.register("faq-accordion", FaqAccordionController)

import FeatureTabController from "./feature_tab_controller"
application.register("feature-tab", FeatureTabController)

import GalleryLightboxController from "./gallery_lightbox_controller"
application.register("gallery-lightbox", GalleryLightboxController)

import GaugeController from "./gauge_controller"
application.register("gauge", GaugeController)

import GuideTabController from "./guide_tab_controller"
application.register("guide-tab", GuideTabController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeroCarouselController from "./hero_carousel_controller"
application.register("hero-carousel", HeroCarouselController)

import HeroImagePickerController from "./hero_image_picker_controller"
application.register("hero-image-picker", HeroImagePickerController)

import HeroVideoPickerController from "./hero_video_picker_controller"
application.register("hero-video-picker", HeroVideoPickerController)

import HomeScenePlayerController from "./home_scene_player_controller"
application.register("home-scene-player", HomeScenePlayerController)

import HomeRevealController from "./home_reveal_controller"
application.register("home-reveal", HomeRevealController)

import IaTableController from "./ia_table_controller"
application.register("ia-table", IaTableController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InputModeController from "./input_mode_controller"
application.register("input-mode", InputModeController)

import InterviewFormController from "./interview_form_controller"
application.register("interview-form", InterviewFormController)

import InterviewKickoffController from "./interview_kickoff_controller"
application.register("interview-kickoff", InterviewKickoffController)

import KlavyAgentController from "./klavy_agent_controller"
application.register("klavy-agent", KlavyAgentController)

import KmongServiceRegistrationDraftController from "./kmong_service_registration_draft_controller"
application.register("kmong-service-registration-draft", KmongServiceRegistrationDraftController)

import PlanningInterviewElapsedController from "./planning_interview_elapsed_controller"
application.register("planning-interview-elapsed", PlanningInterviewElapsedController)

import LandingSectionRepeaterController from "./landing_section_repeater_controller"
application.register("landing-section-repeater", LandingSectionRepeaterController)

import LandingSectionSortableController from "./landing_section_sortable_controller"
application.register("landing-section-sortable", LandingSectionSortableController)

import LandingSectionTypeController from "./landing_section_type_controller"
application.register("landing-section-type", LandingSectionTypeController)

import LocaleDropdownController from "./locale_dropdown_controller"
application.register("locale-dropdown", LocaleDropdownController)

import MegaMenuController from "./mega_menu_controller"
application.register("mega-menu", MegaMenuController)

import MeetingNoteRecorderController from "./meeting_note_recorder_controller"
application.register("meeting-note-recorder", MeetingNoteRecorderController)

import MeetingNoteStatusController from "./meeting_note_status_controller"
application.register("meeting-note-status", MeetingNoteStatusController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import NotificationFilterController from "./notification_filter_controller"
application.register("notification-filter", NotificationFilterController)

import PersonaScrollController from "./persona_scroll_controller"
application.register("persona-scroll", PersonaScrollController)

import PlanningWorkspaceTabsController from "./planning_workspace_tabs_controller"
application.register("planning-workspace-tabs", PlanningWorkspaceTabsController)

import PopupModalController from "./popup_modal_controller"
application.register("popup-modal", PopupModalController)

import PortfolioAnimationsController from "./portfolio_animations_controller"
application.register("portfolio-animations", PortfolioAnimationsController)

import PortfolioCounterController from "./portfolio_counter_controller"
application.register("portfolio-counter", PortfolioCounterController)

import PortfolioMagneticController from "./portfolio_magnetic_controller"
application.register("portfolio-magnetic", PortfolioMagneticController)

import PortfolioMobileMenuController from "./portfolio_mobile_menu_controller"
application.register("portfolio-mobile-menu", PortfolioMobileMenuController)

import PortfolioTiltController from "./portfolio_tilt_controller"
application.register("portfolio-tilt", PortfolioTiltController)

import ProfileDbFormDropzoneController from "./profile_db_form_dropzone_controller"
application.register("profile-db-form-dropzone", ProfileDbFormDropzoneController)

import ProfileHeaderScrollController from "./profile_header_scroll_controller"
application.register("profile-header-scroll", ProfileHeaderScrollController)

import ProfilePageDesignerController from "./profile_page_designer_controller"
application.register("profile-page-designer", ProfilePageDesignerController)

import ProfilePageDesignerModalController from "./profile_page_designer_modal_controller"
application.register("profile-page-designer-modal", ProfilePageDesignerModalController)

import ProfilePageSectionDesignerController from "./profile_page_section_designer_controller"
application.register("profile-page-section-designer", ProfilePageSectionDesignerController)

import ProfileSectionTypeController from "./profile_section_type_controller"
application.register("profile-section-type", ProfileSectionTypeController)

import ProfileSiteMenuController from "./profile_site_menu_controller"
application.register("profile-site-menu", ProfileSiteMenuController)

import ProjectCommentsController from "./project_comments_controller"
application.register("project-comments", ProjectCommentsController)

import SectionImagePickerController from "./section_image_picker_controller"
application.register("section-image-picker", SectionImagePickerController)

import SelectFilterController from "./select_filter_controller"
application.register("select-filter", SelectFilterController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ShareModalController from "./share_modal_controller"
application.register("share-modal", ShareModalController)

import SupportAgentWidgetController from "./support_agent_widget_controller"
application.register("support-agent-widget", SupportAgentWidgetController)

import SubscriptionPlanModalController from "./subscription_plan_modal_controller"
application.register("subscription-plan-modal", SubscriptionPlanModalController)

import TagSelectController from "./tag_select_controller"
application.register("tag-select", TagSelectController)

import TerminalTypingController from "./terminal_typing_controller"
application.register("terminal-typing", TerminalTypingController)

import TermsModalController from "./terms_modal_controller"
application.register("terms-modal", TermsModalController)

import ThumbnailUploadController from "./thumbnail_upload_controller"
application.register("thumbnail-upload", ThumbnailUploadController)

import ToastEditorController from "./toast_editor_controller"
application.register("toast-editor", ToastEditorController)

import UiPlanningEditorController from "./ui_planning_editor_controller"
application.register("ui-planning-editor", UiPlanningEditorController)

import UiUxDesignEditorController from "./ui_ux_design_editor_controller"
application.register("ui-ux-design-editor", UiUxDesignEditorController)

import SlideDesignEditorController from "./slide_design_editor_controller"
application.register("slide-design-editor", SlideDesignEditorController)

import UpgradeNudgeController from "./upgrade_nudge_controller"
application.register("upgrade-nudge", UpgradeNudgeController)

import UserDropdownController from "./user_dropdown_controller"
application.register("user-dropdown", UserDropdownController)

import UserStoryTableController from "./user_story_table_controller"
application.register("user-story-table", UserStoryTableController)

import WelcomeModalController from "./welcome_modal_controller"
application.register("welcome-modal", WelcomeModalController)

import WorkspaceProfileController from "./workspace_profile_controller"
application.register("workspace-profile", WorkspaceProfileController)
